module.exports = __webpack_public_path__ + "static/img/footer-menu-icon05-2.6a27748c.svg";